import React from 'react';
import './Home.css';
import  luna from '../../assets/luna.png';
import Drawer from "../../components/drawer/Drawer";

function Home() {
    return (
        <main id={'container'}>
            <img src={luna} alt={'logo'}/>
            <span>Coucou Dorine, t'es fatiguée ?</span>
            <Drawer />
        </main>
    );
};

export default Home;